const styles = (theme) => ({
  webView: {
    background: theme.webView.background,
  },
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    overflow: 'hidden',
    minHeight: 500,
  },
  titleWrapper: {
    width: '100%',
    padding: 20,
    textAlign: 'center',
    borderBottom: '1px solid #929292',
  },
  title: {
    fontSize: '20px',
    lineHeight: '23px',
  },
  main: {
    width: '90%',
    padding: '25px 0',
  },
  offsetHandlerWrapper: {
    marginTop: 25,
    backgroundColor: theme.backgrounds.cardBackground,
    padding: '35px 45px',
    marginBottom: 150,
  },
  offsetHandlerWrapperMobile: {
    padding: '25px 25px',
  },
  subTitleWrapper: {
    display: 'flex',
    justifyContent: 'center',
    position: 'relative',
    paddingTop: 30,
    flexWrap: 'wrap',
  },
  resetButton: {
    position: 'absolute',
    right: -20,
    top: -15,
    fontSize: '18px',
  },
  subTitle: {
    fontSize: '18px',
    textAlign: 'center',
  },
  subTitleValue: {
    fontSize: '18px',
    opacity: '70%',
  },
  slider: {
    fontSize: '18px',
    margin: '80px 0',
  },
  sliderMobile: {
    '& .MuiSlider-markLabel[data-index="0"]': {
      marginLeft: '10%',
    },
    '& .MuiSlider-markLabel[data-index="2"]': {
      marginLeft: '-10%',
    },
  },
  infoWrapper: {
    display: 'flex',
    alignItems: 'flex-end',
    marginBottom: '10px',
  },
  infoText: {
    fontSize: '18px',
  },
  infoInput: {
    fontSize: '18px',
    opacity: '70%',
  },
  nextButton: {
    width: '100%',
    height: 36,
    marginTop: 20,
  },

})

export default styles
